/**
 * Asynchronously loads the component for NotificationAlert
 */

import { lazyLoad } from 'utils/loadable';

export const NotificationAlert = lazyLoad(
  () => import('./index'),
  module => module.NotificationAlert,
);
